<script lang="ts">
  import { useThrelte } from '@threlte/core'
  import { sceneMode } from '../../stores/scene-mode'
  import { pendingPlacement } from '../../stores/placement'
  import {
    addMaxiPrinterCursor,
    addMiniCursor,
    forbiddenZoneCursor,
    rotateCursor,
    seamCursor,
    translateCursor,
  } from '../../assets/cursors'

  const { renderer } = useThrelte()

  function getPlacementCursor(): string {
    const placement = $pendingPlacement
    if (placement?.type === 'printer') {
      const model = placement.printerModel
      if (model === 'maxiprinter') {
        return `url('${addMaxiPrinterCursor}') 12 12, copy`
      }
      return `url('${addMiniCursor}') 12 12, copy`
    }
    return 'copy'
  }

  const cursorMap: Partial<Record<SceneMode, string>> = {
    translate: `url('${translateCursor}') 12 12, move`,
    rotate: `url('${rotateCursor}') 12 12, crosshair`,
    forbiddenZone: `url('${forbiddenZoneCursor}') 12 12, crosshair`,
    seam: `url('${seamCursor}') 12 12, crosshair`,
  }

  $effect(() => {
    const mode = $sceneMode
    const cursor
      = mode === 'placement'
        ? getPlacementCursor()
        : (cursorMap[mode] ?? 'default')

    renderer.domElement.style.cursor = cursor
  })
</script>
